import React from 'react';
import AssignmentsTable from '../../../../components/AssignmentsTable';
import { FormBlock } from 'Components/Admin/Form';
import { Route } from 'react-router-dom';
import AssignmentForm from '../../../../components/AssignmentsTable/components/AssignmentForm/AssignmentForm';
import AssignmentDelete
  from '../../../../components/AssignmentsTable/components/AssignmentDelete/AssignmentDelete';
import pathToUrl from 'Shared/util/pathToUrl';
import { FormMode } from '../../../../../Admin/constants/constants';
import AppSwitch from 'Components/AppSwitch';

const assignments = [
  {
    id: 1,
    active: true,
    employee: {
      userName: 'Michelle Orozco',
      position: 'Android Development',
    },
    rate: {
      amount: '99999999',
      type: 'hour',
    },
    dateFrom: '01.12.2012',
    dateTo: null,
  },
  {
    id: 2,
    active: true,
    employee: {
      userName: 'See Lu Bacon',
      position: 'Android Development',
    },
    rate: {
      amount: '99999999',
      type: 'hour',
    },
    dateFrom: '01.12.2012',
    dateTo: '06.12.2021',
  },
  {
    id: 3,
    active: true,
    employee: {
      userName: 'Camden Bacon',
      position: 'Android Development',
    },
    rate: {
      amount: '99999999',
      type: 'month',
    },
    dateFrom: '01.12.2012',
    dateTo: null,
  },
  {
    id: 4,
    active: false,
    employee: {
      userName: 'Abriella Bond',
      position: 'Android Development',
    },
    rate: {
      amount: '99999999',
      type: 'month',
    },
    dateFrom: '01.12.2012',
    dateTo: '08.10.202',
  },
  {
    id: 5,
    active: false,
    employee: {
      userName: 'Carmen Velasco',
      position: 'Android Development',
    },
    rate: {
      amount: '99999999',
      type: 'month',
    },
    dateFrom: '01.12.2012',
    dateTo: '08.10.202',
  },
];

const AssignmentsContentForm = ({ match: { path, params } }) => {
  return (
    <div className="assignments-content-form" data-testid="projects-assignments-form">
      <FormBlock title="Assignment employees" subTitle="List of employees who are working on the project.">
        <AssignmentsTable assignments={assignments} currentUrl={pathToUrl(path, params)} />
      </FormBlock>
      <AppSwitch>
        <Route path={path} exact />
        <Route
          path={`${path}create`}
          render={(props) => <AssignmentForm closeUrl={pathToUrl(path, params)} {...props} mode={FormMode.CREATE} />}
        />
        <Route
          path={`${path}update/:id`}
          render={(props) => <AssignmentForm closeUrl={pathToUrl(path, params)} {...props} mode={FormMode.UPDATE} />}
        />
        <Route
          path={`${path}delete/:id`}
          render={(props) => <AssignmentDelete closeUrl={pathToUrl(path, params)} {...props} />}
        />
      </AppSwitch>
    </div>
  );
};

export default AssignmentsContentForm;
